var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFw10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.528,
    height: 47,
    viewBox: "0 0 41.528 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1733",
    "data-name": "Group 1733",
    transform: "translate(-1104 -324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reload",
    transform: "translate(1104 324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    "data-name": "Group 1730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4774",
    "data-name": "Path 4774",
    d: "M29.805,26.236a20.764,20.764,0,0,0,41.528,0,1.232,1.232,0,0,0-2.463,0,18.3,18.3,0,1,1-18.3-18.3h2.137l-3.055,3.42A1.232,1.232,0,1,0,51.488,13l4.367-4.889a2.106,2.106,0,0,0,0-2.808L51.488.411a1.232,1.232,0,1,0-1.837,1.641l3.055,3.42H50.569A20.788,20.788,0,0,0,29.805,26.236Z",
    transform: "translate(-29.805)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_10",
    "data-name": 10,
    transform: "translate(1124.688 353.297)",
    fill: "#fafafa",
    fontSize: 16,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -8,
    y: 0
  }, "10")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFw10);
export default __webpack_public_path__ + "static/media/fw10.899f97916718b844e99998c77970a5ad.svg";
export { ForwardRef as ReactComponent };